<template>
  <div class="about-additional-info">
    <div class="row row-text-and-img">
      <div class="text-group">
        <p>{{ $t("about-8") }}</p>
        <p>{{ $t("about-8-1") }}</p>
        <!-- <p>{{ text2 }}</p> -->
      </div>
      <div
        class="bg-img"
        :style="{
          backgroundImage: `url(${require('../../assets/img/about/img3.jpg')})`,
        }"
      ></div>
    </div>
    <div class="row row-text-and-img">
      <div
        class="bg-img"
        :style="{
          backgroundImage: `url(${require('../../assets/img/about/img4.jpg')})`,
        }"
      ></div>
      <div class="text-group">
        <h2>{{ $t("about-9") }}</h2>
        <ul>
          <li>
            <a class="link-basic" href="https://bami.bg/bg/" target="_blank">{{
              $t("about-10-4")
            }}</a>
          </li>
        </ul>
        <h2>{{ $t("about-10") }}</h2>
        <ul>
          <li>
            <a
              class="link-basic"
              href="https://www.ila-lead.org/"
              target="_blank"
              >{{ $t("about-10-1") }}</a
            >
          </li>
          <li>
            <a
              class="link-basic"
              href="https://www.zinc.org/"
              target="_blank"
              >{{ $t("about-10-2") }}</a
            >
          </li>
          <li>
            <a
              class="link-basic"
              href="http://www.ilzsg.org/static/home.aspx"
              target="_blank"
              >{{ $t("about-10-3") }}</a
            >
          </li>
        </ul>
        <!-- <h2></h2> -->
        <!-- <p>
          <a
            class="link-basic"
            target="_blank"
            :href="`/files/zmip_2020_${$i18n.locale}.pdf`"
            >{{ $t("about-11") }}</a
          >
        </p> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["text2"],
};
</script>

<style lang="scss" scoped>
.row-text-and-img {
  .text-group,
  .bg-img {
    width: 50%;
  }
  .bg-img {
    background-size: cover;
    background-position: center;
  }
  .text-group {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 $sidesPadding;
    // width: 50%;
    p,
    h2,
    h1 {
      width: 100%;
    }
  }
}
.row-text-and-img:first-child {
  .text-group {
    padding-right: $sidesPadding / 2;
  }
}
.row-text-and-img:last-child {
  .text-group {
    padding-left: $sidesPadding;
  }
}
@media screen and (max-width: 1600px) {
  .row-text-and-img {
    .text-group {
      padding: 0 $sidesPadding1600;
    }
  }
  .row-text-and-img:first-child {
    .text-group {
      padding-right: $sidesPadding1600 / 2;
    }
  }
  .row-text-and-img:last-child {
    .text-group {
      padding-left: $sidesPadding1600;
    }
  }
}
@media screen and (max-width: 1280px) {
  .row-text-and-img {
    .text-group {
      padding: 0 $sidesPadding1280;
    }
  }
  .row-text-and-img:first-child {
    .text-group {
      padding-right: $sidesPadding1280 / 2;
    }
  }
  .row-text-and-img:last-child {
    .text-group {
      padding-left: $sidesPadding1280;
    }
  }
}
@media screen and (max-width: 800px) {
  .row-text-and-img {
    flex-direction: column;
    .text-group,
    .bg-img {
      width: 100%;
      min-height: 30vw;
    }
  }
  .about-additional-info {
    .row-text-and-img {
      .text-group {
        padding: 0 $sidesPadding1280;
      }
    }
  }
  .row-text-and-img:last-child {
    flex-direction: column-reverse;
  }
}
@media screen and (max-width: 600px) {
  .about-additional-info {
    .row-text-and-img {
      .text-group {
        padding: 0 $sidesPadding600;
      }
    }
  }
}
</style>

